<template lang="html">
  <div>
    <div class="flex-box">
      <div id="polygon" class="shape" @mouseup="drawAPoint">
        <img :src="`${publicImagePath}/ruler.png`" class="ruler" />
        <canvas id="preloadCanvas" v-if="showPreload" />
        <div class="foot-0 number-indicator small-text">0</div>
        <div class="foot-10 number-indicator small-text">10</div>
        <div class="foot-20 number-indicator small-text">20</div>
        <div class="foot-30 number-indicator small-text">30</div>
        <div class="foot-40 number-indicator small-text">40ft</div>
        <div
          v-for="(point, index) in points"
          :key="'distance' + index"
          :class="distanceClass(index)"
          :style="distanceIndicatorPosition(index)"
        >
          {{distanceOfPoint(index)}}
        </div>

        <div
          v-for="(point, index) in points"
          :key="'angel' + index"
          :class="angleClass(index)"
          :style="`left: ${point[0]}px; top: ${point[1]}px;`"
        >
          <div v-if="angleOfPoint(index)">
            {{angleOfPoint(index)}} °
          </div>
        </div>
      </div>
      <div>
        <div v-if="done">
          <SymbiumButton
            text="Restart Drawing"
            :onClick="resetDrawing"
            :isSmall="true"
            :isDialog="true"
          />
        </div>
        <div v-if="!done" class="help-container">
          <div class="body-16">Click in the box on the left to begin drawing your design’s building footprint</div>
          <div class="gap-1x" />
          <div class="body-14 gray">Press Ctrl + Z to undo</div>
          <div class="gap-1x" />
          <div class="body-14 gray">Hold Shift to draw in orthographic mode</div>
          <div class="gap-1x" />
          <div class="body-14 gray">To finish drawing, press Enter or click the first point in your drawing</div>
          <FooterHelper />
        </div>
      </div>

    </div>

    <div class="flex-box" v-show="false">
      <div>
        <b>Generated hover image</b><br>
        <canvas id="hover"></canvas>
      </div>
      <div class="guidance">
        <div v-if="!done">
          <div>Press Ctrl+z to undo</div>
          <div>Press Enter to finish</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import FooterHelper from 'src/components/dashboard/shares/FooterHelper.vue'

import SVG from './js/svg.js'
import svgDraw from './js/svg.draw.js'

svgDraw(SVG)
export default {
  components: { SymbiumButton, FooterHelper },
  props: ["aduDrawingPoints"],
  data() {
    return {
      points: [],
      activePointIndex: 0,
      gridUnit: 60,
      multipler: 1.5,
      levels: [30, 40, 60],
      polygon: null,
      done: false,
      showPreload: false,
      isValid: true,
    }
  },
  methods: {
    distanceClass(index) {
      return `indicator disctance-indicator ${index == this.activePointIndex - 1 ? 'active' : ''}`;
    },
    angleClass(index) {
      return `indicator angle-indicator ${index == this.activePointIndex && !this.done ? 'on-mouse' : ''} ${(index == this.activePointIndex - 1) ? 'active' : ''}`;
    },
    calcPolygonArea() {
      var total = 0;

      for (var i = 0, l = this.points.length; i < l; i++) {
        var addX = this.points[i][0];
        var addY = this.points[i == this.points.length - 1 ? 0 : i + 1][1];
        var subX = this.points[i == this.points.length - 1 ? 0 : i + 1][0];
        var subY = this.points[i][1];

        total += (addX * addY * 0.5);
        total -= (subX * subY * 0.5);
      }

      return (Math.abs(total)) / 64;
    },
    generateHoverImage(pts,widget,w,h) {
      var dpi = window.devicePixelRatio;
      this.fix_dpi(widget,dpi);
      var x = pts.map(i=>i[0]),
          y = pts.map(i=>i[1]),
          minX = Math.min(...x), maxX = Math.max(...x),
          minY = Math.min(...y), maxY = Math.max(...y),
          width = maxX-minX,
          height = maxY-minY,
          widthScale = w/width,
          heightScale = h/height,
          scale = Math.min(widthScale, heightScale)*dpi,
          ctx = widget.getContext('2d');

      ctx.translate(widget.width,0);
      if (widthScale > heightScale) {
        ctx.translate((width * scale - widget.width) /2,0);
      } else {
        ctx.translate(0,(widget.height - height * scale) /2);
      }
      ctx.scale(-1,1);
      var transformedPoints = _.map(pts, (pt) => {
        return [pt[0] - minX, pt[1] - minY]
      })
      transformedPoints = _.map(transformedPoints, (pt) => {
        return [pt[0] * scale, pt[1] * scale]
      })
      ctx.fillStyle = "#5F74FE";
      ctx.beginPath();
      ctx.moveTo(...transformedPoints[0]);
      transformedPoints.slice(1).forEach(i=>ctx.lineTo(...i));
      ctx.closePath();
      ctx.fill();
      return;
    },
    fix_dpi(canvas,dpi) {
      var style_height = getComputedStyle(canvas).getPropertyValue("height").slice(0,-2),
          style_width = getComputedStyle(canvas).getPropertyValue("width").slice(0,-2);
      canvas.setAttribute('height', style_height * dpi);
      canvas.setAttribute('width', style_width * dpi);
    },
    turningAngleBetween(p1,p2,p3) {
      var bearing = (x, y) => { return Math.atan2(y[1]-x[1],y[0]-x[0])*180/Math.PI };
      var b1 = bearing(p1,p2), b2 = bearing(p2,p3); b1 = b1 < 0? 360 + b1: b1; b2 = b2 < 0? 360 + b2: b2; b2 = b2 - b1; return b2 > 180? b2 - 360: b2 < -180? 360 + b2: b2;
    },
    angleBetween(A,B,C) {
      var AB = Math.sqrt(Math.pow(B[0]-A[0],2)+ Math.pow(B[1]-A[1],2));
      var BC = Math.sqrt(Math.pow(B[0]-C[0],2)+ Math.pow(B[1]-C[1],2));
      var AC = Math.sqrt(Math.pow(C[0]-A[0],2)+ Math.pow(C[1]-A[1],2));
      var angleInPi = Math.acos((BC*BC+AB*AB-AC*AC)/(2*BC*AB));
      var angleInDegree = ((angleInPi * 180) / Math.PI)
      if(angleInDegree) {
        return angleInDegree.toFixed(1)
      } else {
        return null;
      }
    },
    angleOfPoint(index) {
      if (this.points.length < 3 ) return 0;
      var pts = [...this.points];
      if (pts[0] == pts[this.points.length - 1]) {
        if (index == this.points.length - 1) {
          return
        }

        pts.pop()
      }
      var current = pts[index];
      var next;
      var previous;
      if (index == pts.length - 1) {
        next = pts[0];
        previous = pts[index - 1];
      } else if(index == 0) {
        next = pts[index + 1];
        previous = pts[pts.length - 1];
      } else {
        next = pts[index + 1];
        previous = pts[index - 1];
      }
      return this.angleBetween(previous, current, next)
    },
    distance(p1,p2) {
      return Math.round(Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2)));
    },
    currentPointAndNext(index) {
      var current = this.points[index]
      var next;
      if(index != this.points.length - 1) {
        next = this.points[index + 1]
      } else {
        next = this.points[0]
      }

      return [current, next];
    },
    distanceIndicatorPosition(index) {
      var currentAndNext = this.currentPointAndNext(index)
      var left = (currentAndNext[0][0] + currentAndNext[1][0]) / 2
      var top = (currentAndNext[0][1] + currentAndNext[1][1]) / 2
      return `left: ${left}px; top: ${top}px;`
    },
    distanceOfPoint(index) {
      var currentAndNext = this.currentPointAndNext(index)
      var distanceInInch = this.distance(currentAndNext[0], currentAndNext[1]) * this.multipler;
      var ft = parseInt(distanceInInch / 12)
      var inch = distanceInInch % 12
      return ft + "' " + parseInt(inch) + '"'
    },
    isClockwise (pts) {
      return pts.slice(0,-2).map((i,j) => this.turningAngleBetween(pts[j],pts[j+1],pts[j+2])).reduce((t,x)=>t+x,0) > 0;
    },
    getPolygonDim(points) {
      var data = {};
      if (points.length >= 3) {
        data["bbox"] = [this.polyline.width(), this.polyline.height()];
        data["aduDrawingPoints"] = this.points
        data["dim"] = [];
        for(var i = 0; i < points.length; i++) {
          var start = points[i], end, next;
          if (i <= points.length - 3) {
            end = points[i+1];
            next = points[i+2];
          } else if(i == points.length - 2) {
            end = points[i+1];
            next = points[0];
          } else {
            end = points[0];
            next = points[1];
          }

          data["dim"].push(this.distance(start, end) * this.multipler);
          data["dim"].push(this.turningAngleBetween(start, end, next));
        }
      }
      data["dim"] = data["dim"].slice(0, -5)
      return data;
    },
    drawAPoint() {
      var coords = this.polyline.array().value;
      if (coords.length < 3) return;
      var first = coords[0],
          last = coords[coords.length - 1],
          last_but1 = coords[coords.length - 2];

      if ((first[0] == last[0] && first[1] == last[1]) || (last_but1[0] == last[0] && last_but1[1] == last[1])) {
        this.completeDrawing(true)
      }
    },
    isDrawingOnStartPoint() {

    },
    zoom(ratio) {
      return _.map(this.points, (point) => {
        return [parseInt(point[0] * ratio), parseInt(point[1] * ratio)]
      })
    },
    initDrawing() {
      var draw = SVG('polygon').size('100%', '100%');
      this.done = false;
      this.showPreload = false;
      this.points = [];
      this.polyline = draw.polyline().draw({snapToGrid:4, snapToAxis: 0}).attr('stroke-width',1).attr('fill','none');
      this.polyline.on('drawstart', () => {
        document.addEventListener('keydown', (e) => {
          // press Enter
          if(e.keyCode == 13){
            this.completeDrawing()
          }
          if(e.keyCode == 16) {
            this.polyline.draw('param', 'snapToAxis', 1)
          }
          // press Ctrl + z
          var evtobj = window.event? event : e
          if(evtobj.ctrlKey) {
            if (evtobj.keyCode == 90) {
              this.polyline.plot(this.polyline.array().value.slice(0, -1))
              this.points = this.polyline.array().value;
            }
          }
        });
      });
      document.addEventListener('keyup', (e) => {
        if(e.keyCode == 16) {
          this.polyline.draw('param', 'snapToAxis', 0)
        }
      });
      this.polyline.on('drawupdate', () => {
        var coords = this.polyline.array().value
        this.points = coords;
        this.activePointIndex = coords.length - 1
      })
      this.polyline.on('drawdone', () => {
        this.polyline.fill('#5F74FE')
        this.polyline.stroke('#5F74FE')
        this.done = true;
      })
    },
    resetDrawing() {
      var oldCanvas = document.querySelector('#polygon svg')
      oldCanvas.parentNode.removeChild(oldCanvas)
      this.initDrawing()
      this.$emit('finish-drawing', { dimension: [], aduFootPrint: null, footPrintSize: null });
    },
    completeDrawing() {
      this.polyline.draw('done');
      this.polyline.off('drawstart');
      var pts = this.polyline.array().value;
      pts.push(pts[0])
      this.points = pts
      this.polyline.plot(pts)
      //transpose it if height < width
      if (this.polyline.height() < this.polyline.width()) {
        pts = pts.map(i=>[i[1],i[0]]);
      }
      var canvas =  document.querySelector("canvas")
      console.log('ICW')
      if(this.isClockwise(pts)) {
        console.log('ICW')
        pts = pts.reverse();
      }
      this.generateHoverImage(pts,canvas,144,192);
      var dim = this.getPolygonDim(pts);
      var footPrintSize = this.calcPolygonArea();
      this.$emit('finish-drawing', {
        dimension: dim,
        aduFootPrint: canvas.toDataURL(),
        footPrintSize,
      });
      this.activePointIndex = 0;
    },
    loadCurrentDesign() {
      if(_.isEmpty(this.aduDrawingPoints)) return;
      this.done = true
      this.showPreload = true
      this.$nextTick(() => {
        var aduDrawingPoints = this.aduDrawingPoints
        var canvas = document.getElementById("preloadCanvas")
        var ctx = canvas.getContext('2d');
        ctx.canvas.width = '480'
        ctx.canvas.height = '480'
        ctx.fillStyle = "#5F74FE";
        ctx.beginPath();
        ctx.moveTo(...aduDrawingPoints[0]);
        _.each(aduDrawingPoints.slice(1), (point) => {
          ctx.lineTo(...point)
        })
        ctx.closePath();
        ctx.fill();
      })
    }
  },
  mounted() {
    this.initDrawing()
    this.loadCurrentDesign()
  },
}
</script>

<style lang="scss" scoped>

#hover {
  height: 192px;
  width: 144px;
  background: red;
}

div.shape{
  min-width: 480px;
  max-width: 480px;
  height: 480px;
  border-bottom: 1px solid #DCDFFB;
  border-right: 1px solid #DCDFFB;
  position: relative;
  margin-right: 24px;
  background:
    linear-gradient(to right, #DCDFFB 1px, transparent 1px) 0px 0px / 40px 40px,
    linear-gradient(to right, #EEEFFD 1px, transparent 1px) 8px 0px / 40px 40px,
    linear-gradient(to right, #EEEFFD 1px, transparent 1px) 16px 0px / 40px 40px,
    linear-gradient(to right, #EEEFFD 1px, transparent 1px) 24px 0px / 40px 40px,
    linear-gradient(to right, #EEEFFD 1px, transparent 1px) 32px 0px / 40px 40px,
    linear-gradient(to bottom, #DCDFFB 1px, transparent 1px) 0px 0px / 40px 40px,
    linear-gradient(to bottom, #EEEFFD 1px, transparent 1px) 0px 8px  / 40px 40px,
    linear-gradient(to bottom, #EEEFFD 1px, transparent 1px) 0px 16px  / 40px 40px,
    linear-gradient(to bottom, #EEEFFD 1px, transparent 1px) 0px 24px  / 40px 40px,
    linear-gradient(to bottom, #EEEFFD 1px, transparent 1px) 0px 32px  / 40px 40px,
    ;
  .ruler {
    position: absolute;
    bottom: 24px;
    left: 80px;
  }
  .number-indicator {
    position: absolute;
    bottom: 3px;
    &.foot-0 {
      left: 80px;
    }
    &.foot-10 {
      left: 160px;
    }
    &.foot-20 {
      left: 240px;
    }
    &.foot-30 {
      left: 320px;
    }
    &.foot-40 {
      left: 400px;
    }
  }
  .indicator {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    background: transparent;
    padding: 10px 0 0 10px;
    margin-top: -10px;
    margin-right: -10px;
    color: #21275B;
    font-size: 12px;
    text-shadow: -1px -1px 0 #FCFCFF, 1px -1px 0 #FCFCFF, -1px 1px 0 #FCFCFF, 1px 1px 0 #FCFCFF;


    &.active, &:hover {
      opacity: 1;
      padding: 0;
    }

    &:hover {
      cursor: none;
    }

    &.on-mouse {
      margin-left: 10px;
      margin-top: 10px;
    }
  }
}

.help-container {
  position: relative;
  height: 100%;

  .footer-helper {
    position: absolute;
    bottom: 0;
    margin-bottom: 0;
  }
}

#preloadCanvas {
  width: 480px;
  height: 480px;
}

.guidance {
  margin-left: 40px;
  margin-top: 20px;
}
</style>
